import styled from "styled-components";

export const Container = styled.div`
  display: flex;

  max-width: 1280px;
  margin: 0 auto;

  padding-bottom: 182px;
`;

export const Main = styled.div`
  flex-grow: 1;
`;
